import React from "react";
import Classroom from "../../assets/images/Classroom-Management.jpg";
const Hero = () => {
  return (
    <section className="home-slider position-relative">
      <div
        id="carouselExampleInterval"
        className="carousel slide"
        data-bs-ride="carousel"
      >
        <div className="carousel-inner">
          <div className="carousel-item active" data-bs-interval={3000}>
            <div
              className="bg-home d-flex align-items-center"
              style={{
                background: `url("${Classroom}") center center`,
              }}
            >
              <div className="bg-overlay" />
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-lg-12 text-center">
                    <div className="title-heading mt-4">
                      <h1 className="heading mb-3 text-white title-dark animated fadeInUpBig animation-delay-2">
                        Thank you for visiting our beta site
                      </h1>
                      <p className="para-desc text-light para-dark mx-auto animated fadeInUpBig animation-delay-4">
                        ProfBot is a work in progress focused on using chatbots
                        in the classroom to increase student success.
                      </p>
                      <div className="mt-4 pt-2 animated fadeInUpBig animation-delay-7">
                        <a href="#start" className="btn btn-primary mt-2">
                          <i className="uil uil-envelope" /> Get Started
                        </a>
                      </div>
                    </div>
                  </div>
                  {/*end col*/}
                </div>
                {/*end row*/}
              </div>
              {/*end container*/}
            </div>
            {/*end slide*/}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
